export type NovaAgentShape = 'SINGLE_OUTPUT' | 'CONVERSATIONAL';

export interface AgentFormValues {
	name: string;
	categoryId: string | null;
	title: string;
	description: string;
	shape: NovaAgentShape;
}

export const DEFAULT_AGENT_FORM: AgentFormValues = {
	name: '',
	categoryId: null,
	title: '',
	description: '',
	shape: 'SINGLE_OUTPUT',
};

export function validateAgentForm(
	values: AgentFormValues,
	existingNames: string[]
): {isValid: boolean; missing: Array<keyof AgentFormValues>; duplicateName: boolean} {
	const missing: Array<keyof AgentFormValues> = [];
	if (!values.name.trim()) {
		missing.push('name');
	}
	if (!values.categoryId) {
		missing.push('categoryId');
	}
	if (!values.title.trim()) {
		missing.push('title');
	}
	if (!values.description.trim()) {
		missing.push('description');
	}
	const duplicateName = values.name.trim().length > 0 && existingNames.includes(values.name.trim());
	return {isValid: missing.length === 0, missing, duplicateName};
}
